const segmentForm = {
  bindings: {
    viewMode: '<',
    segments: '<',
    currentSegments: '<',
    onEdit: '&',
  },
  templateUrl:
    '/modules/pis-tool/common/segment-form/segment-form.html',
  controller: 'SegmentFormController',
};

angular
  .module('pis-common.module')
  .component('segmentForm', segmentForm);
